function pay() {
  const urlParams = new URLSearchParams(window.location.search);
  const transactionId = urlParams.get('_ptxn');
  Paddle.Checkout.open({
    transactionId,
  });
}

function setup() {
  console.log('Initializing Paddle');
  Paddle.Initialize({
    token: 'live_7065d3abffa3906834d39f7e8fd',
  });
  document.getElementById('paynow').addEventListener('click', pay);
  console.log('Finished Initializing Paddle');
}

window.onload = setup;
